"use client";

import { logServer } from '@/actions/api_request';
import { getUserStatus } from '@/actions/users';
import { useLoading } from '@/contexts/loading';
import { UserStatus } from '@/enums/userStatus.enum';
import { useSession } from 'next-auth/react';
import Image from 'next/image';
import { useRouter, useSearchParams } from 'next/navigation';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface BlockTemplateClientProps {
  page?: string;
}

const BlockTemplateClient = ({ page }: BlockTemplateClientProps) => {
  const { t } = useTranslation();
  const { showLoading, hideLoading } = useLoading();

  const { update, status: sessionStatus } = useSession();
  const [hasSessionUpdated, setHasSessionUpdated] = useState(false);

  const [showMessage, setShowMessage] = useState(true);
  const router = useRouter();
  const redirectPath = useSearchParams()?.get("redirectPath") || "";

  const checkUserStatus = async () => {
    try {
      const response = await getUserStatus(update);
      if (response.status === 200) {
        const userStatus = response.data?.status;

        await update({ user: { user_status: userStatus } });
        setHasSessionUpdated(true); // Prevent multiple updates

        hideLoading();
        if (userStatus === UserStatus.Verified && redirectPath) {
          router.push(`${redirectPath}`);
          return;
        }
      }
    } catch (error) {
      console.error("Error fetching user status:", error);
      logServer("page: block/unregister, fetching user status: ", error);
    } finally {
      hideLoading();
      setShowMessage(true);
    }
  };

  useEffect(() => {
    if (hasSessionUpdated || sessionStatus !== 'authenticated') {
      return;
    }

    if (page === "unregister") {
      checkUserStatus();
    }
  }, [sessionStatus]);

  useEffect(() => {
    if (page === "unregister") {
      setShowMessage(false)
      showLoading();
    } else {
      setShowMessage(true)
    }
  }, []);

  return (
    <div className="min-h-screen flex flex-col justify-center">
      {!showMessage ? (
        <></>
      ) : (
        <div className="w-full pt-5 flex flex-grow flex-col justify-center items-center">
          <div className="w-full pt-5 flex flex-col justify-center items-center">
            <div className="w-full pt-5 flex flex-col justify-center items-center">
              <Image
                width={90}
                height={90}
                src="/block.svg"
                alt="block url icon"
              />
              <div className="pt-5 font-light text-lg whitespace-pre-line text-center">
                {t("blockUrlTitle")}
              </div>
              <div className="pt-5 font-light text-sm whitespace-pre-line text-center">
                {t("blockUrlMassageInformation")}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BlockTemplateClient;
